<div class="modal-container">
    <div class="modal-body p-0">
        <div class="container">
            <div class="row">
                <div class="col-lg-12 d-flex justify-content-end p-0">
                    <button type="button" class="close" (click)="dialogRef.close(true)" style="border: 0px;background-color: transparent;margin: 10px">
                        <img src="./../../../../assets/img/x-white.svg" class="img-fluid ico-title" />
                    </button>
                </div>
                <div class="col-lg-12 d-flex align-items-center flex-column">
                    <img src="./assets/img/banner_promo_julio.gif" width="800" height="450" />
                </div>
            </div>
        </div>
    </div>
</div>

